import { render, staticRenderFns } from "./input.vue?vue&type=template&id=19a236c2&scoped=true&"
import script from "./input.ts?vue&type=script&lang=ts&"
export * from "./input.ts?vue&type=script&lang=ts&"
import style0 from "./input.scss?vue&type=style&index=0&id=19a236c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a236c2",
  null
  
)

export default component.exports